export default "__VITE_ASSET__BbpF7Uv6__"